import { type FC, type Key, useState } from "react";

import { Button, TreeSelect, type TreeSelectNode } from "@snapchat/snap-design-system";

import { filterDropdown, treeSelectStyle } from "./shared";

interface TargetingSpecFilterProps {
    treeData: TreeSelectNode[];
    onCheck: (checkedKeys: Key[], triggeringKey: Key) => void;
    resetFilter: () => void;
}

export const TargetingSpecFilter: FC<TargetingSpecFilterProps> = ({ treeData = [], onCheck, resetFilter }) => {
    const [checkedKeys, setCheckedKeys] = useState<Key[]>([]);

    const onCheckKey = (keys: Key[], key: Key) => {
        setCheckedKeys(() => keys);
        onCheck(keys, key);
    };

    const onReset = () => {
        setCheckedKeys(() => []);
        resetFilter();
    };

    return (
        <div className={filterDropdown}>
            <TreeSelect
                checkedKeys={checkedKeys}
                onCheck={onCheckKey}
                popoverProps={{ placement: "bottomLeft", className: treeSelectStyle }}
                treeData={treeData}
                trigger="click"
                triggerElement={<Button>Filters</Button>}
                footer={
                    <Button onClick={onReset} type={"link"}>
                        Reset Filter
                    </Button>
                }
            />
        </div>
    );
};
